import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Sku } from "../../../models";

@Component({
    selector: "brain-sku",
    templateUrl: "./sku.component.html",
    styleUrls: ["./sku.component.scss"]
})
export class SkuComponent {
  @Input()
  public sku: Sku;

  @Input()
  public skuId;

  @Output()
  openPlans: EventEmitter<string> = new EventEmitter<string>();

  /**
   * emitting data to parent component so that only one sku's payment plan could be open -
   * shutting down all sku arrows and adding arrow only to the clicked one
   */
  activePlan(): void {
      this.openPlans.emit(this.sku.sku_id);
      if (document.getElementsByClassName("arrow")[this.sku.sku_id]) {
          document.getElementsByClassName("arrow")[this.sku.sku_id].classList.add("visible");
          document.getElementsByClassName("sku__button")[this.sku.sku_id].classList.add("default");
      }
  }
}
